'use client'
import { onEvent } from '@dynamic-labs-sdk/client';
import { dynamicEvents } from '../../../../../events/dynamicEvents.js';

const syncEvents = (client) => {
    onEvent(client, 'mfaCompletionSuccess', ({ mfaToken }) => {
        dynamicEvents.emit('mfaCompletionSuccess', { mfaToken });
    });
    onEvent(client, 'mfaCompletionFailure', ({ error }) => {
        dynamicEvents.emit('mfaCompletionFailure', { error });
    });
};

export { syncEvents };
